module.exports = __webpack_public_path__ + "img/a32ea83.jpg";